"use strict";

import "core-js/modules/es.promise.js";
import { AG_API_KEY, GRAPH_SERVICE_API } from '@autoguru/global-configs';
import { Observable } from 'relay-runtime';
import { relayLogFn } from './environment';
import { createGraphError } from './utils';
export const fetchQuery = ({
  getToken,
  scheme: _scheme = 'Bearer'
} = {}) => (params, variables, _cacheConfig, _uploadables) => Observable.create(sink => {
  const id = params.id || params.cacheID;
  const postBody = params.id !== null ? {
    id: params.id,
    variables
  } : {
    id: params.cacheID,
    query: params.text,
    variables
  };
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': AG_API_KEY
  };
  Promise.resolve().then(async () => {
    let maybeToken = '';
    // biome-ignore lint/suspicious/noAssignInExpressions: migration quick fix. To be fixed when code is touched
    if (maybeToken = await (getToken === null || getToken === void 0 ? void 0 : getToken())) headers['Authorization'] = `${_scheme} ${maybeToken}`;
    const response = await globalThis.fetch(`${GRAPH_SERVICE_API}/graphql`, {
      method: 'POST',
      cache: 'no-cache',
      headers,
      body: JSON.stringify(postBody)
    });
    const responseData = await response.json();
    if (!responseData || Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.errors)) {
      const error = createGraphError(responseData === null || responseData === void 0 ? void 0 : responseData.errors);
      if (!(responseData !== null && responseData !== void 0 && responseData.data)) throw error;
      relayLogFn({
        name: 'network.error',
        error,
        networkRequestId: id
      });
      if (responseData !== null && responseData !== void 0 && responseData.errors) sink.error(responseData.errors);
    }
    sink.next(responseData);
    sink.complete();
  }).catch(error => {
    sink.error(error);
  });
});